"use client";

import { useEffect } from "react";

import { identifyUser, setUserProperties } from "@/lib/tracking/posthog";

import { useAuth } from "@/dashboard/contexts/auth-context";

export function PostHogAuthIntegration() {
  const { user, tenants, activeTenantId, isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated && user) {
      // Identify the user in PostHog
      identifyUser(user.id, {
        email: user.email,
        name: `${user.firstName} ${user.lastName}`,
        first_name: user.firstName,
        last_name: user.lastName,
        user_id: user.id,
        tenant_count: tenants.length,
        active_tenant_id: activeTenantId,
        is_multi_tenant: tenants.length > 1,
      });

      // Set additional user properties
      setUserProperties({
        tenant_ids: tenants.map(t => t.id),
        tenant_names: tenants.map(t => t.name),
        login_timestamp: new Date().toISOString(),
      });
    }
  }, [isAuthenticated, user, tenants, activeTenantId]);

  // Track tenant switching
  useEffect(() => {
    if (isAuthenticated && activeTenantId) {
      const activeTenant = tenants.find(t => t.id === activeTenantId);
      if (activeTenant && user) {
        setUserProperties({
          active_tenant_id: activeTenantId,
          active_tenant_name: activeTenant.name,
          tenant_switch_timestamp: new Date().toISOString(),
        });
      }
    }
  }, [activeTenantId, tenants, isAuthenticated, user]);

  return null; // This component doesn't render anything
}
